import Api from './Api';

class DCXToolingService {
    dcxTooling = {};

    getDCXToolingTypes = () => {
        return Api.fetch(`/api/dcxTooling/dcxToolingTypes`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    executeQuery = (queryName, params, paramInfo) => {
    const queryObject = {
            queryName: queryName,
            parameters: params,
            parameterInfo: paramInfo
        };
        return Api.fetch(`/api/dcxTooling/executeQuery`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(queryObject)
        })
            .then((res) => {
                return res.json();
            })
            .catch(this.handleError);
    }

    getUniversalParamaterData = () => {
        return Api.fetch(`/api/dcxTooling/getUniversalParamaterData`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    getAllPersonasAndRoles = () => {
        return Api.fetch(`/api/dcxTooling/getAllPersonasAndRoles`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }


    editPersonaRoles = (personaRoles) => {
        return Api.fetch(`/api/dcxTooling/editPersonaRoles`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(personaRoles)
        })
            .then((res) =>
                this.normalizeToString(res))
            .catch(this.handleError);
    };

    addPersonaRoles = (personaRoles) => {
        return Api.fetch(`/api/dcxTooling/addPersonaRoles`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(personaRoles)
        })
            .then((res) => this.normalizeToString(res))
            .catch(this.handleError);
    };

    deletePersona = (personaId) => {
        return Api.fetch(`/api/dcxTooling/deletePersona/${personaId}`, {
            method: 'DELETE'
        })
            .then((res) => this.normalizeToString(res))
            .catch(this.handleError);
    };


    getQueryText = (queryName) => {
        return Api.fetch(`/api/dcxTooling/getQueryText/${queryName}`)
            .then((res) => { return res; })
            .catch(this.handleError);
    }

    handleError = (e) => {
        console.log("Failed to load dcxTooling.");
        console.log(e);
    }

    handleResponse = (response) => {
        if (response) {
            return response.json();
        }
    }


    readMessage = async (res) => {
        try {
            const contentType = res.headers?.get?.('content-type') || '';

            if (contentType.includes('application/json')) {
                const data = await res.json();
                if (typeof data === 'string') return data;
                if (typeof data?.message === 'string') return data.message;
                if (typeof data?.Message === 'string') return data.Message;
                // Fall back to a compact JSON string
                return JSON.stringify(data);
            }

            const text = await res.text();
            if (text && text.trim().length) {
                return text.trim();
            }
            return res.ok ? 'Success' : `Request failed (${res.status})`;
        }
        catch (e) {
            return res?.ok ? 'Success' : `Request failed (${res?.status ?? 'unknown'})`;
        }
    };

    normalizeToString = async (res) => {
        const msg = await this.readMessage(res);
        if (!res.ok) {
            throw new Error(msg || `Request failed (${res.status})`);
        }
        return msg;
    };

}

export default new DCXToolingService();